import { styled } from '@mui/material';
import { Field } from 'formik';
import { assetValidations } from '@shared/constants/lists';
import { RadioButtonListField } from '@shared/fields/RadioButtonListField';
import { FormFieldLabel } from '@styles/Shared/StyledFormFields';
import { GridItem } from '@shared/styledComponents';
import { IFormFieldConfig } from '@shared/components/FormFieldsConstructor';

const ValidationFormFieldLabel = styled(FormFieldLabel)`
  line-height: 2;
`;

export function createAssetValidationOptions(prefix: string) {
  return assetValidations.map(({ label, value }) => ({
    value: value,
    label: `${label}`,
    name: `${prefix}-${value}`,
  }));
}
export const ValidationForm = () => {
  const formConfig: IFormFieldConfig[] = [
    {
      width: '100%',
      name: 'assetValidations.isLiftKit',
      label: 'Is there a lift kit?',
      type: 'label',
    },
    {
      name: 'assetValidations.isLiftKit',
      label: 'Is there a lift kit?',
      options: createAssetValidationOptions('assetValidations.isLiftKit'),
      component: RadioButtonListField,
    },
    {
      width: '100%',
      name: 'assetValidations.isSixInchLiftKit',
      label: 'Is there a lift kit greater than six inches?',
      type: 'label',
    },
    {
      width: '100%',
      name: 'assetValidations.isSixInchLiftKit',
      label: 'Is there a lift kit greater than six inches?',
      options: createAssetValidationOptions('assetValidations.isSixInchLiftKit'),
      component: RadioButtonListField,
    },
    {
      width: '100%',
      name: 'assetValidations.isHEV',
      label: 'Is vehicle a HEV?',
      type: 'label',
    },
    {
      width: '100%',
      name: 'assetValidations.isHEV',
      label: 'Is vehicle a HEV? ',
      options: createAssetValidationOptions('assetValidations.isHEV'),
      component: RadioButtonListField,
    },
    {
      width: '100%',
      name: 'assetValidations.doesOversizeUndersizeTire',
      label: 'Does it have oversized/undersized tires?',
      type: 'label',
    },
    {
      width: '100%',
      name: 'assetValidations.doesOversizeUndersizeTire',
      label: 'Does it have oversized/undersized tires?',
      options: createAssetValidationOptions('assetValidations.doesOversizeUndersizeTire'),
      component: RadioButtonListField,
    },
  ];

  return (
    <>
      {formConfig.map(({ name, label, component, ...rest }, index) => (
        <GridItem
          key={index}
          style={rest?.type !== 'label' ? { paddingTop: '0px', marginBottom: '5px' } : {}}
        >
          {rest?.type === 'label' ? (
            <ValidationFormFieldLabel>{label}</ValidationFormFieldLabel>
          ) : (
            <Field
              {...rest}
              name={name}
              label={label}
              component={component}
              sx={{ m: 0, px: 1 }}
            />
          )}
        </GridItem>
      ))}
    </>
  );
};
